import React, { useState, useEffect } from "react";
import Text from "../../images/text_icon.svg";
import Amount from "../../images/amount_icon.svg";
import Brought from "../../images/amount.svg";
import {
  FormControlLabel,
  Button,
  Dialog,
  DialogContent,
  Autocomplete,
} from "@mui/material";
import { FormControl, InputLabel, RadioGroup, Radio } from "@mui/material";
import { MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { addTransaction } from "./transactionSlice";
import Repo from "../../Repository/Repo";
import ClipLoader from "react-spinners/ClipLoader";
import { Toast } from "../components/Toast";
import { getLedgersNames } from "../../components/ledgers/ledgersNamesSlice";
import useGetBanks from "../../pages/bank/useGetBanks";
import S3FileUpload from "react-s3/lib/ReactS3";
import Config from "../../utils/Config";

function AddTransaction({ onClose, onSuccess, balance, status }) {
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.daybookCat);
  const [loading, setLoading] = useState(false);
  const [amountRadio, setAmountRadio] = useState("outgoing");
  const [selectedAccountNumber, setSelectedAccountNumber] = useState(0);
  const [itemImg, setItemImg] = useState(null);

  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  const userName = localStorage.getItem("username");

  const [state, setState] = useState({
    nameNumber: "",
    broughtForward: "",
    amount: "",
    date: "",
    category: "",
    type: "",
    ledgerId: "",
    ledgerName: "",
    balance: 0,
    depositTo: "",
    forwardType: "add",
  });

  useEffect(() => {
    if (ledgersNames.length == 0) {
      dispatch(getLedgersNames());
    }
  }, []);
  const { banks } = useGetBanks();

  console.log("ledgerName", state.ledgerName);
  const handleInput = (e) => {
    const { name, value } = e.target;
    console.log("value", value);
    if (name == "category") {
      setState((prev) => ({ ...prev, [name]: value, nameNumber: "" }));
    } else {
      if (name == "depositTo") {
        const selectedBank = e.target.value;
        console.log("ssssss',selectedBank", selectedBank);
        setSelectedAccountNumber(selectedBank.accountNumber);
      }
      setState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleImage = (e) => {
    // setState((pre) => ({ ...pre, imgFile: e.target.files[0] }));\
    if (e.target?.files?.length > 0) {
      setItemImg(e.target.files[0]);
    } else {
      setItemImg(null);
    }
  };
  const handleLedger = (e, val) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      ledgerId: val._id,
      ledgerName: val.name,
      balance: val.saleTotal,
    }));
    console.log("val", val);
  };

  const paymentCashBankHandler = async (id) => {
    console.log("id", id);

    let method =
      state.type === "Cash" ? "paymentyByCashInHand" : "paymentByBank";
    const currentDate = new Date();

    // Extract day, month, and year
    const day = String(currentDate.getDate()).padStart(2, "0"); // Ensures two digits
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = currentDate.getFullYear();

    // Format the date as dd-mm-yyyy
    const formattedDate = `${day}-${month}-${year}`;

    console.log(formattedDate);
    let { data } = await Repo.banks({
      request: {
        method: method,
        data: {
          company_code: localStorage.getItem("companyCode"),
          ledgerId: "",
          credit: 0,
          debit: Number(state.amount),
          paymentId: id,
          from: state.type == "Cash" ? "cashInHand" : userName,
          to: amountRadio == "incoming" ? userName : "",
          description: state.nameNumber,
          bankId: state?.depositTo?._id,
          date: formattedDate,
        },
      },
    });

    console.log("dataa", data);
  };
  const formatDate = () => {
    const day = String(new Date().getDate()).padStart(2, "0");
    const month = String(new Date().getMonth() + 1).padStart(2, "0");
    const year = new Date().getFullYear();
    console.log("day", `${year}/${month}/${day}`);

    return `${year}-${month}-${day}`;
  };
  const saveDaybook = async () => {

    if (itemImg) {
      S3FileUpload.uploadFile(itemImg, Config()).then(async (dataImg) => { 
console.log("data.location",dataImg.location)
    try {
      if (!state.amount) {
        Toast("info", "Kindly add amount or broad forward");
        return;
      }
      // if (!state.date) {
      //   Toast("info", "Kindly Select Date");
      //   return;
      // }

      if (status) {
        setLoading(true);
        let { data } = await Repo.datebook({
          request: {
            method: "saveDateBook",
            data: {
              dateBook: {
                nameNumber: state.nameNumber,
                credit: amountRadio == "incoming" ? Number(state.amount) : 0,
                debit: amountRadio == "outgoing" ? Number(state.amount) : 0,
                company_code: localStorage.getItem("companyCode"),
                date: moment(state.date).format("DD-MM-YYYY") || formatDate(),
                category: state.category,
                imgURL:dataImg.location,

                // receiver:"",
                // type: "Bank",
                // bankId: "1234567890",
                // payer: localStorage.getItem("username"),
                // ledgerId: "",
              },
            },
          },
        });

        setLoading(false);
        if (data?.response?.data?.dateBook) {
          console.log("data:", data);
          console.log("data:", data.response.status.statusCode);
          const res = data.response.status.statusCode;
          await res;
          const paymentId = data.response.data.dateBook;

          console.log("payment", paymentId);
          await paymentCashBankHandler(paymentId);
          onSuccess();
        } else {
          Toast("error", "Error");
          onClose();
        }

      
      } else {
        let record = {
          ...state,
          created_at: Date.now() / 1000,
        };
        if (amountRadio == "outgoing") {
          record.credit = 0;
          record.debit = state.amount;
        } else {
          record.credit = state.amount;
          record.debit = 0;
        }
        delete record.amount;
        dispatch(addTransaction(record));
        onClose();
      }
    } catch (err) {
      console.log("err:", err);
      Toast("error", err);
    }
  })} else{

    try {
      if (!state.amount) {
        Toast("info", "Kindly add amount or broad forward");
        return;
      }
 

      if (status) {
        setLoading(true);
        let { data } = await Repo.datebook({
          request: {
            method: "saveDateBook",
            data: {
              dateBook: {
                nameNumber: state.nameNumber,
                credit: amountRadio == "incoming" ? Number(state.amount) : 0,
                debit: amountRadio == "outgoing" ? Number(state.amount) : 0,
                company_code: localStorage.getItem("companyCode"),
                date: moment(state.date).format("DD-MM-YYYY") || formatDate(),
                category: state.category,

              },
            },
          },
        });

        setLoading(false);
        if (data?.response?.data?.dateBook) {
          console.log("data:", data);
          console.log("data:", data.response.status.statusCode);
          const res = data.response.status.statusCode;
          await res;
          const paymentId = data.response.data.dateBook;

          console.log("payment", paymentId);
          await paymentCashBankHandler(paymentId);
          onSuccess();
        } else {
          Toast("error", "Error");
          onClose();
        }

      
      } else {
        let record = {
          ...state,
          created_at: Date.now() / 1000,
        };
        if (amountRadio == "outgoing") {
          record.credit = 0;
          record.debit = state.amount;
        } else {
          record.credit = state.amount;
          record.debit = 0;
        }
        delete record.amount;
        dispatch(addTransaction(record));
        onClose();
      }
    } catch (err) {
      console.log("err:", err);
      Toast("error", err);
    }


  } 
  };

  const handleAmountRadio = (e) => {
    setAmountRadio(e.target.value);
  };

  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="sm">
      <DialogContent>
        <Stack spacing={1}>
          {status && (
            <div className="flex-sec">
              <div className="right-sec">
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel>Select Category</InputLabel>
                  <Select
                    id="outlined-basic"
                    label="Select Category"
                    variant="outlined"
                    name="category"
                    value={state.category || ""}
                    onChange={handleInput}
                  >
                    <MenuItem value="">
                      <Typography sx={{ fontStyle: "italic" }}>
                        Select Category
                      </Typography>
                    </MenuItem>
                    {categories.map((item, i) => {
                      return (
                        <MenuItem key={i} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            </div>
          )}

          {/* <div className="flex-sec">
           <div className="right-sec">
           <Autocomplete
            autoFocus
            size="small"
            value={state.ledgerName}
            onChange={(e, val) => {
              handleLedger(e, val);
            }}
            fullWidth
            getOptionLabel={(option) => option?.name || ""}
            options={ledgersNames}
            renderInput={(params) => (
              <TextField autoFocus {...params} label="Select Ledger" />
            )}
          />
   </div>
   </div> */}
          <div className="flex-sec">
            <div className="right-sec">
              <FormControl sx={{ width: "100%" }}>
                <InputLabel>Select Type</InputLabel>
                <Select
                  id="outlined-basic"
                  label="Select Type"
                  variant="outlined"
                  name="type"
                  value={state.type || "Other"}
                  onChange={handleInput}
                >
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="Bank">Bank</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          {state.type == "Bank" && (
            <div className="flex-sec">
              <div className="right-sec">
                <FormControl fullWidth size="small">
                  <InputLabel>Bank Name</InputLabel>
                  <Select
                    size="small"
                    name="depositTo"
                    value={state.depositTo}
                    label="Bank Name"
                    onChange={handleInput}
                  >
                    {banks.map((item, i) => {
                      return (
                        <MenuItem key={i} value={item}>
                          {item.bankName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            </div>
          )}
          {state.type == "Bank" && (
            <>
              <div className="flex-sec">
                <div className="right-sec">
                  <TextField
                    name="amount"
                    type="number"
                    sx={{ marginTop: "0px !important" }}
                    //  label="Account No"
                    disabled={true}
                    value={selectedAccountNumber}
                  ></TextField>
                </div>
              </div>
            </>
          )}
          <div className="flex-sec">
            <div className="text-ico">
              <img src={Text} alt="text" />
            </div>
            <TextField
              className="detail-txt"
              id="outlined-basic"
              label="Detail"
              variant="outlined"
              name="nameNumber"
              value={state.nameNumber}
              onChange={handleInput}
            />
          </div>

          <div className="flex-sec">
            <div className="text-ico">
              <img src={Amount} alt="Amount" className="hide-xs" />
            </div>
            <TextField
              className="detail-txt"
              name="amount"
              label="Amount"
              variant="outlined"
              type="number"
              value={state.amount}
              onChange={handleInput}
            />
          </div>
          <div className="flex-sec">
            <TextField
              className="detail-txt"
              multiple
              variant="outlined"
              type="file"
              onChange={handleImage}
              />
          </div>
          <div className="flex-sec">
            <div className="right-sec">
              <RadioGroup className="radio-adj" value={amountRadio}>
                <div
                  className={`radio-border ${
                    amountRadio === "outgoing" && "border-green"
                  }`}
                >
                  <FormControlLabel
                    value="outgoing"
                    control={<Radio className="green" />}
                    onChange={handleAmountRadio}
                    label="Outgoing"
                  />
                </div>
                <div
                  className={`radio-border ${
                    amountRadio === "incoming" && "border-green"
                  }`}
                >
                  <FormControlLabel
                    value="incoming"
                    control={<Radio className="green" />}
                    onChange={handleAmountRadio}
                    label="Incoming"
                  />
                </div>
              </RadioGroup>
            </div>
          </div>
          {/* <div className="flex-sec">
            <div className="text-ico">
              <img src={Brought} alt="Amount" className="hide-xs" />
            </div>
            <TextField
              className="detail-txt"
              id="outlined-basic"
              type="number"
              label="Brought forward"
              variant="outlined"
              name="broughtForward"
              value={state.broughtForward}
              onChange={handleInput}
            />
          </div>
          <div className="flex-sec">
            <div className="right-sec">
              <RadioGroup
                className="radio-adj"
                value={state.forwardType}
                name="forwardType"
                onChange={handleInput}
              >
                <div
                  className={`radio-border ${
                    state.forwardType === "add" && "border-green"
                  }`}
                >
                  <FormControlLabel
                    value="add"
                    control={<Radio className="green" />}
                    label="Add"
                  />
                </div>
                <div
                  className={`radio-border ${
                    state.forwardType === "subtract" && "border-green"
                  }`}
                >
                  <FormControlLabel
                    value="subtract"
                    control={<Radio className="green" />}
                    label="Subtract"
                  />
                </div>
              </RadioGroup>
            </div>
          </div> */}
          <div className="flex-sec">
            <div className="right-sec radio-adj">
              <Typography
                className="date-label"
                sx={{ fontSize: { md: "16px", xs: "10px" } }}
              >
                Transaction date:
              </Typography>
              <div>
                <TextField
                  id="date"
                  size="small"
                  required
                  // className={classes.datePick}
                  type="date"
                  name="date"
                  onChange={handleInput}
                  value={state.date || formatDate()}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
          </div>
          {loading && (
            <Stack
              mt="20px"
              width="100%"
              alignItems="center"
              justifyContent="center"
            >
              <ClipLoader size={30} color="#4eaf51" loading={true} />
            </Stack>
          )}
          {!loading && (
            <Stack
              mt="20px"
              direction="row"
              width="100%"
              justifyContent="space-between"
            >
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  background: "rgb(138, 138, 138) !important",
                }}
                onClick={toggle}
              >
                Cancel
              </Button>
              <Button
                sx={{
                  textTransform: "none",
                }}
                variant="contained"
                onClick={saveDaybook}
              >
                Add Transaction
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddTransaction;
